module.exports = __webpack_public_path__ + "static/media/shape2.pngfeat1.dfdcb3e7.png";